let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2d8bz")).then(() => parcelRequire('cztee'));